
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SiteNewsUpdateForm from "@/form/Settings/site/newsUpdate";

@Component({
  components: {FormGroup},
})
export default class NewsUpdateForm extends Vue {
  @Prop() form!: SiteNewsUpdateForm;

  async created(): Promise<void> {
    console.log('creted');
  }
}
